import React from "react";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

const handleRenderOption = (option, {inputValue}) => {
  const matches = match(option, inputValue);
  const parts = parse(option, matches);

  const highlightStyle = {
    fontWeight: 700,
    backgroundColor: "lightyellow",
    padding: "2px 2px"
  };

  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </div>
  );
};

export default handleRenderOption;
